import { FormDialog } from 'components/dialog/form'

import { TargetListResult, useEditTargetList } from 'interface/search/targetList'
import { TargetListForm, useTargetListForm } from '../form/targetListForm'

type EditTargetListDialogProps = {
  searchId: number
  targetList: TargetListResult
  onSubmit: (result: TargetListResult) => void
  onClose: () => void
}
export const EditTargetListDialog = ({
  searchId,
  targetList,
  onSubmit,
  onClose
}: EditTargetListDialogProps) => {
  const form = useTargetListForm(targetList)
  const [postState, submit] = useEditTargetList(searchId, targetList.listId, { onEditted: onSubmit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth='sm'
      title="ターゲットリスト情報編集"
      isLoading={postState.posting}
      error={postState.error}
      body={<TargetListForm {...form}/>}
      submitLabel="保 存"
      isValid={
        form.formState.isValid &&
        !form.formState.isSubmitting
      }
      onSubmit={() => form.handleSubmit(data => {
        submit({
          listName: data.listName,
          description: data.description ?? ''
        })
      })}
      onClose={onClose}
    />
  )
}
